import React, { useEffect, useState } from "react";
import CloseIcon from "../assets/images/CloseIcon";

interface PopupLogoutProps {
    show: boolean;
    title: string;
    desc?: string;
    confirmLabel?: string;
    onClose: () => void;
    onOpen: () => void;
}

const PopupLogout: React.FC<PopupLogoutProps> = ({ show, title, onOpen, onClose, desc, confirmLabel = "Confirm" }) => {
    const [showPopup, setShowPopup] = useState(show);

    useEffect(() => {
        setShowPopup(show);
    }, [show]);

    return (
        <div
            className={`absolute w-full h-full  top-0 left-0 flex items-center justify-center ${showPopup ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                } transition-opacity duration-300 ease-in-out`}
            style={{ backgroundColor: "#22252552", zIndex: "200", transition: "opacity 0.3s ease, visibility 0.3s ease", width: "100vw", height: "100vh", left: 0, top: 0 }}
        >
            <div
                className={`transform transition-transform duration-300 ease-in-out ${showPopup ? "translate-y-0" : "translate-y-4 opacity-0"}`} style={{
                    padding: "24px", borderRadius: "24px", backgroundColor: "#FFFFFF", width: "530px", transition: "transform 0.3s ease, opacity 0.3s ease",
                }}
            >
                <div className="flex items-center justify-between">
                    <p style={{ fontSize: '20px', color: '#222525' }} className="font-semibold font-inter leading-[24px]">
                        {title}
                    </p>
                </div>
                <div className="flex items-center justify-between" style={{ marginTop: '12px' }}>
                    <p className="text-[14px] font-inter leading-[24px]" style={{ color: '#6A7878' }}>
                        {desc}
                    </p>
                </div>
                <div className="flex items-center justify-center" style={{ marginTop: '24px', gap: '12px' }}>
                    <div
                        onClick={() => { onClose(); }}
                        className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
                        style={{
                            borderRadius: "40px",
                            padding: "10px 24px",
                            backgroundColor: '#0F7679',
                            color: '#FFFFFF',
                        }}
                    >
                        {confirmLabel}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupLogout;